import styled from '@emotion/styled'

const RelatedArticlesItemContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`

export default RelatedArticlesItemContent